import React, { useState, useEffect } from "react";
import { getAccessTokenApi, logout, decodedToken } from "../api/auth";
import { OBJ_ROLES } from "../utils/constants";

export const AuthContext = React.createContext();

export default function AuthProvider(props) {
  const { children } = props;

  const [usuario, setUsuario] = useState({
    usuario: null,
    isLoading: true,
    isAdmin: null,
    isRegistrador: null
  });

  useEffect(() => {
    checkUserLogin(setUsuario);
  }, []);
  //console.log(user, "setUSer");

  return <AuthContext.Provider value={usuario}>{children}</AuthContext.Provider>;
}

/**
 * Revisa si el usuario esta logueado
 * Si los token estan bien estructurados, decodifica el valor del token de acceso y devuelve sus valores: {id, name, lastname, username, role}
 * @param {Function} setUser
 */
async function checkUserLogin(setUser) {
  const accessToken = getAccessTokenApi();

  if (!accessToken) {
    logout();
    setUser({
      usuario: null,
      isLoading: false,
      isAdmin: null,
      isRegistrador: null,
      isVisitante: null
    });
  } else {
    const usuario = decodedToken(accessToken);

    setUser({
      isLoading: false,
      usuario: usuario,
      isAdmin: usuario.idrol === OBJ_ROLES.ADMINISTRADOR,
      isRegistrador: usuario.idrol === OBJ_ROLES.REGISTRADOR,
      isVisitante: usuario.idrol === OBJ_ROLES.VISITANTE
    });
  }
}
